import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import api from '../../utils/api';
import { PartnerEndpoints } from '../../utils/endpoints';
import AuthLayout from '../auth/AuthLayout';
import { Alert, Button, FormField } from '../ui';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setTempToken, setIsFirstLogin } = useAuth();

  useEffect(() => {
    const notice = sessionStorage.getItem('loginNotice');
    if (notice) {
      setError(notice);
      sessionStorage.removeItem('loginNotice');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post(PartnerEndpoints.login, { email, password });
      const { token, requires_2fa, is_first_login } = response.data.data;

      if (requires_2fa) {
        setTempToken(token);
        setIsFirstLogin(is_first_login);
        navigate(is_first_login ? '/2fa/setup' : '/2fa/verify');
      }
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Sign in" subtitle="Sign in to your CashAfrica partner dashboard">
      <form onSubmit={handleSubmit}>
        {error && (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        )}

        <FormField label="Email address" htmlFor="email" required>
          <input
            type="email"
            id="email"
            className="form-control"
            placeholder="name@domain.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </FormField>

        <FormField label="Password" htmlFor="password" required>
          <input
            type="password"
            id="password"
            className="form-control"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </FormField>

        <div className="flex items-center gap-2 mb-6">
          <input
            id="keep-me"
            type="checkbox"
            className="form-check-input"
            checked={keepSignedIn}
            onChange={(e) => setKeepSignedIn(e.target.checked)}
          />
          <label htmlFor="keep-me" className="form-check-label">
            Keep me signed in
          </label>
        </div>

        <Button type="submit" size="lg" loading={loading} className="w-full">
          Sign in
        </Button>

        <p className="mt-6 text-center text-sm text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
          Lost access? Ask a teammate to resend your invite from Settings → Team.
        </p>
      </form>
    </AuthLayout>
  );
};

export default Login;
